// extracted by mini-css-extract-plugin
export var dataCell = "_np-2";
export var dataRow = "_np-0";
export var headerRow = "_np-1";